import { z } from "zod/v4";
import {
  CameraSubject,
  ClientApiFeaturePathParams,
  SingleResponse,
  defineEndpoint,
  defineResource,
} from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

export type RecordActivityPathParams = ClientApiFeaturePathParams;

export const RecordActivityBody = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("livestream_viewed"),
  }),
  z.object({
    kind: z.literal("clip_viewed"),
    clipId: z.string().min(1),
  }),
]);
export type RecordActivityBody = z.output<typeof RecordActivityBody>;

export const ActivityRecordItem = z.object({
  subject: CameraSubject,
  kind: z.enum(["livestream_viewed", "clip_viewed"]),
  clipId: z.string().optional(),
  recordedAt: z.iso.datetime(),
});
export type ActivityRecordItem = z.output<typeof ActivityRecordItem>;

export const RecordActivityResponse = SingleResponse(ActivityRecordItem);
export type RecordActivityResponse = z.output<typeof RecordActivityResponse>;

export const activityResource = defineResource({
  feature: FEATURE_NAME,
  resource: "items",
});

export const recordActivityEndpoint = defineEndpoint(activityResource, {
  method: "POST",
  bodySchema: RecordActivityBody,
  responseSchema: RecordActivityResponse,
});
